import ScreenModules from "screen";
import Element from "app/element";
function Screens() {
  const screens = initScreens();
  let screenShown = null;
  async function goto(screenName, data) {
    console.log("goto", screenShown, "->", screenName);
    await hideScreen(screenShown);
    screenShown = screenName;
    return await showScreen(screenShown, data);
  }
  async function hideScreen(screenName) {
    if (!screenName) return;
    console.log("hide", screenName);
    const screen = screens[screenName];
    console.log("hidden", screenName);
    screen.classList.add("hidden");
  }
  async function showScreen(screenName, data) {
    if (!screenName) return;
    if (!(screenName in screens)) throw new Error(`Unknown screen! (${screenName})`);
    const screen = screens[screenName];
    screen.setVisible(true);
    screen.focus();
    return await screen.show(data);
  }
  return {
    goto
  };
}
function initScreens() {
  const elements = document.querySelectorAll(".screen");
  const screens = {};
  elements.forEach(element => {
    const {
      id
    } = element;
    if (!(id in ScreenModules)) {
      console.warn(`Could not load screen module for element ${id}!`);
      return;
    }
    screens[id] = ScreenModules[id](Element(element));
  });
  return screens;
}
export default Screens;